import {SearchIcon} from '@primer/octicons-react'
import {Box, Spinner, Octicon} from '@primer/react'
import {useInput} from './context'

export const FilterInputIcon = () => {
  const {showSpinner} = useInput()

  return (
    <Box
      sx={{
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'row',
        justifyItems: 'flex-start',
      }}
    >
      {showSpinner ? (
        <Spinner size="small" sx={{ml: '4px', mr: 2}} />
      ) : (
        <Octicon icon={SearchIcon} aria-label="Search" sx={{ml: '4px', mr: 2, color: 'fg.muted'}} />
      )}
    </Box>
  )
}

try{ FilterInputIcon.displayName ||= 'FilterInputIcon' } catch {}